import { Box, CircularProgress, Paper, Typography } from "@mui/material";

export const SummaryCard = ({ title, value, loading = false }) => {
  return (
    <Paper elevation={3} width="100%" sx={{ padding: 2 }}>
      {loading ? (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          height={100}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box
          height={100}
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <Typography component="p" fontSize={40} fontWeight="bold">
            {value || 0}
          </Typography>
          <Typography
            component="p"
            fontSize={{
              xs: "0.8rem",
              md: 14,
            }}
          >
            {title}
          </Typography>
        </Box>
      )}
    </Paper>
  );
};
